import React from 'react';
import {
  Box,
  HorizontalDivider,
  TransparentButton,
  Typography,
  CashIcon,
  CryptoIcon,
  GridContainerWithTitle,
} from '@ttx/design-system';

export interface PaymentMethodModalProps {
  onClose: () => void;
  onPressCrypto: () => void;
  onPressCash: () => void;
}

export const PaymentMethodModal: React.FC<PaymentMethodModalProps> = ({
  onClose,
  onPressCrypto,
  onPressCash,
}) => {
  const options = [
    {
      id: 'crypto',
      icon: <CryptoIcon />,
      label: 'Pay with crypto',
      onPress: onPressCrypto,
    },
    {
      id: 'cash',
      icon: <CashIcon />,
      label: 'Pay with cash',
      onPress: onPressCash,
    },
  ];
  return (
    <GridContainerWithTitle
      title="Payment method"
      onModalClose={onClose}
      maxWidth={480}
    >
      {options.map(({id, icon, label, onPress}, idx) => {
        const isLast = idx === options.length - 1;
        return (
          <Box key={id}>
            <Box p="lg" flexDirection="row">
              <Box width="120px">{icon}</Box>
              <TransparentButton onPress={onPress}>
                <Typography
                  textStyle="s"
                  color="textDefault"
                  textDecoration="underline"
                >
                  {label}
                </Typography>
              </TransparentButton>
            </Box>
            {!isLast && <HorizontalDivider />}
          </Box>
        );
      })}
    </GridContainerWithTitle>
  );
};
